<template>
  <b-row>
    <b-col
      cols="12"
      class="pt-3"
    >
      <span
        class="individual-analysis__title mr-lg-3"
      >
        <strong>
          {{ $t('fields.engineering.chromatography.sample') }}:
        </strong>
        {{ sample.number }}
      </span>
      <router-link
        :to="editSampleRoute"
        target="_blank"
      >
        <b-button
          class="mr-1 mt-1 mt-lg-0"
          size="sm"
          variant="outline-secondary"
        >
          <s-icon
            name="edit-paper"
            class="mr-1"
          />
          {{ $t('actions.edit') }}
        </b-button>
      </router-link>
      <b-button
        class="mr-1 mt-1 mt-lg-0"
        size="sm"
        variant="outline-secondary"
        @click="openPrintPage"
      >
        <s-icon
          name="print"
          class="mr-1"
        />
        {{ $t('actions.print') }}
      </b-button>
      <b-button
        class="individual-analysis__subtitle-button mt-1 mt-lg-0"
        size="sm"
        variant="outline-secondary"
        @click="goToDetails"
      >
        <span class="material-icons-round">
          bookmark_border
        </span>
        {{ $t('general.subtitle') }}
      </b-button>
      <summary-transformer-info
        class="my-3"
      />
      <b-form-checkbox
        class="individual-analysis__only-alarmed-check my-2 my-lg-3 no-bold"
        v-model="showOnlyAlarmedMethodsProxy"
      >
        {{
          $t('engineering.chromatography.methods-and-diagnostics.individual-analysis.' +
            'show-only-alarmed-methods')
        }}
      </b-form-checkbox>
    </b-col>
    <details-modal
      :value="showModal"
      @input="handleModal"
    />
  </b-row>
</template>

<script>
import tabNames from '@/domain/enums/installation/engineering/chromatography/chromatographyTabs';
import SummaryTransformerInfo
  from '@/domain/components/installation/supervision/SummaryTransformerInfo';
import print from '@/services/print';
import DetailsModal from '../DetailsModal';

export default {
  components: {
    DetailsModal,
    SummaryTransformerInfo,
  },
  data: () => ({
    showModal: false,
  }),
  props: {
    sample: Object,
    showOnlyAlarmedMethods: Boolean,
  },
  computed: {
    editSampleRoute() {
      return {
        name: 'monitoring.engineering.module',
        query: {
          tab: tabNames.SAMPLE,
          sampleId: this.sample.id,
        },
      };
    },
    gasInformation() {
      return this.sample ? this.sample.gasInformation : [];
    },
    gasInformationGroups() {
      if (this.gasInformation.length > 5) {
        const middle = Math.ceil(this.gasInformation.length / 2);
        return [
          this.gasInformation.slice(0, middle),
          this.gasInformation.slice(middle, this.gasInformation.length),
        ];
      }

      return [
        this.gasInformation,
      ];
    },
    gasInfoFields() {
      return [
        {
          key: 'gas',
          label: this.$t('fields.engineering.chromatography.gas-information.gas'),
        },
        {
          key: 'value',
          label: this.$t('fields.engineering.chromatography.gas-information.value'),
        },
        {
          key: 'rate',
          label: this.$t('fields.engineering.chromatography.gas-information.rate'),
        },
      ];
    },
    showOnlyAlarmedMethodsProxy: {
      get() {
        return this.showOnlyAlarmedMethods;
      },
      set(value) {
        return this.$emit('update:showOnlyAlarmedMethods', value);
      },
    },
  },
  methods: {
    print,
    handleModal(value) {
      this.showModal = value;
    },
    goToDetails() {
      this.handleModal(true);
    },
    openPrintPage() {
      const routeData = this.$router.resolve({
        name: 'clean-view.chromatography.methods-and-diagnostics.individual-analysis.print',
        params: {
          ...this.$route.params,
          sampleId: this.sample.id,
        },
        query: {
          alarmedOnly: this.showOnlyAlarmedMethods,
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="sass" scoped>
@import ~@/styles/defaults/mixins
@import "src/styles/defaults/mobile-first"

.individual-analysis
  &__title
    font-size: 1.4rem
    vertical-align: top
    +media-max-md()
      display: block

  ::v-deep &__gas-info-table
    font-size: .8rem
    +media-min-xl()
      max-width: 13rem
      display: inline-table

  &__gas-info-separator
    display: none
    +media-min-xl()
      &:not(:last-child)
        display: inline-block
        background-color: var(--color-background-regular)
        border-radius: .2rem
        width: .35rem
        height: 80%
        margin-left: .5rem
        margin-right: .7rem
        +md-box-shadow-2

  &__subtitle-button
    & span.material-icons-round
      font-size: 1.2rem
      vertical-align: bottom
</style>
